module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-Medium.3e00014e.woff2";